module.exports = __webpack_public_path__ + "img/z4.4a39f3d8.png";